import { Component, input } from '@angular/core';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { JssModule, TextField } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-content-single-column-text-section',
  standalone: true,
  imports: [CommonUiUtilityComponentsModule, JssModule],
  templateUrl: './content-single-column-text-section.component.html',
  styleUrls: [
    './content-single-column-text-section.component.ed.scss',
    './content-single-column-text-section.component.essent.scss',
  ],
})
export class ContentSingleColumnTextSectionComponent {
  readonly heading = input.required<TextField>();
  readonly richText = input.required<TextField>();
}
